import {Pipe, PipeTransform} from '@angular/core';
import {TenantInformationService} from '../services/tenant-information.service';
import {environment} from '../../environments/environment';

@Pipe({
  name: 'tenantSpecificAsset'
  }
)
export class TenantSpecificAssetPipe implements PipeTransform {

  constructor(private readonly tenantInformationService: TenantInformationService) {
  }

  transform(value: string): string {
    return this.tenantSpecificAssetsPath + value;
  }

  private get tenantSpecificAssetsPath(): string {
    return `${environment.themesAndAssetsUrl}${environment.name}/assets/${this.tenantInformationService.getTenantName()}/`;
  }
}
